import httpClient from "./httpClient";

const attributeTemplatesGet = lang =>
  httpClient.get(`/attributeTemplates/${lang}`);

const attributeTemplatesCreate = (lang, data) =>
  httpClient.post(`/attributeTemplates/${lang}`, data);

const attributeTemplatesUpdate = (id, lang, data) =>
  httpClient.put(`/attributeTemplates/${id}/${lang}`, data);

const attributeTemplatesDelete = id =>
  httpClient.delete(`/attributeTemplates/${id}`);

export {
  attributeTemplatesGet,
  attributeTemplatesCreate,
  attributeTemplatesUpdate,
  attributeTemplatesDelete
};
